'use client'

import { useEffect } from "react";
import { initializeLoggingGate } from "@/utils/logging";

export default function LoggingGate() {
  useEffect(() => {
    initializeLoggingGate();
  }, []);
  return null;
}


